<template>
  <AnnotationView />
</template>


<script>
import AnnotationView from "@/components/review/AnnotationView";
import Store from "./AnnotationView.store";

export default {
  components: { AnnotationView },
  created() {
    this.$store.loadStoreModule({ module: Store });
  },
};
</script>